export class ParceiroEstimativaView {    
        id: number;
        parceiroId: number;
        estimativaId: number;
        solucao: string;
        quantidade: number;
        valor: number;
        dtInclusao: string;
        dtAlteracao: string;
        parceiro: string;
        estimativa: string
    
  }
  